import * as Sentry from "@sentry/react";
export class PostProductData {
    constructor() {
        this.handle = async (data_) => {
            var _a, _b, _c;
            const apiUrl = process.env.REACT_APP_API_URL;
            try {
                const url = new URL(`/products`, apiUrl);
                const response = await fetch(url.toString(), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data_),
                });
                if (!response.ok) {
                    const errorBody = await response.text().catch(() => "");
                    const bodySuffix = errorBody ? ` Body: ${errorBody}` : "";
                    throw new Error(`Failed to create product in Shopify (status: ${response.status}).${bodySuffix}`);
                }
                const data = await response.json();
                const variantId = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.variants) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : data === null || data === void 0 ? void 0 : data.id;
                if (variantId) {
                    return variantId;
                }
                throw new Error("Shopify response did not include a variant id.");
            }
            catch (error) {
                Sentry.captureException(error);
                throw error;
            }
        };
    }
}
